const DEFAULT_FACE_QUALITY_MESSAGE =
  'We could not capture a clear view of your face. Please remove anything covering your face, face the camera squarely, and try again.';

const DEFAULT_NO_FACE_MESSAGE =
  'No face detected in the image. Please capture a clear photo of your face.';

const DEFAULT_EMAIL_EXISTS_MESSAGE =
  'This email is already registered. Please use a different email or try logging in.';

const DEFAULT_CONNECTION_MESSAGE =
  'Onboarding failed. Please check your internet connection and try again.';

const DEFAULT_FAILED_MESSAGE = 'Onboarding failed. Please try again.';

/**
 * Map axios error from POST /registration/onboard to a user-facing message.
 * @param {import('axios').AxiosError} error
 * @param {{ emailExistsMessage?: string, connectionMessage?: string }} [options]
 * @returns {string}
 */
export function getOnboardRegistrationErrorMessage(error, options = {}) {
  const data = error?.response?.data || {};
  const apiMsg = data.message;
  const apiError = data.error;
  const status = error?.response?.status;

  if (status === 403 && apiMsg) {
    return apiMsg;
  }

  if (status === 409 || apiError === 'email_exists') {
    return apiMsg || options.emailExistsMessage || DEFAULT_EMAIL_EXISTS_MESSAGE;
  }

  if (apiError === 'no_face_detected') {
    return apiMsg || DEFAULT_NO_FACE_MESSAGE;
  }

  if (apiError === 'face_quality') {
    return apiMsg || DEFAULT_FACE_QUALITY_MESSAGE;
  }

  if (
    apiError === 'liveness_failed' ||
    apiError === 'liveness_session_expired' ||
    apiError === 'liveness_session_invalid' ||
    apiError === 'liveness_required' ||
    apiError === 'liveness_no_reference_image'
  ) {
    return (
      apiMsg ||
      'Face liveness verification did not pass. Please try again in good lighting with your face in the oval.'
    );
  }

  if (status === 404 && apiError === 'tenant_not_found') {
    return apiMsg || 'Tenant not found. Please contact support.';
  }

  if (status === 400 && apiMsg) {
    return apiMsg;
  }

  if (status === 400) {
    return 'Invalid data provided. Please check your information and try again.';
  }

  if (apiMsg) {
    return apiMsg;
  }

  return options.connectionMessage || DEFAULT_CONNECTION_MESSAGE;
}

export {
  DEFAULT_FACE_QUALITY_MESSAGE,
  DEFAULT_NO_FACE_MESSAGE,
  DEFAULT_EMAIL_EXISTS_MESSAGE,
  DEFAULT_CONNECTION_MESSAGE,
  DEFAULT_FAILED_MESSAGE,
};
